// import com.walltech.cargo.model.Invoice;
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import ChargeCountItem from './ChargeCountItem'
import BigNumber from 'bignumber.js'
import * as NumberUtils from '@/utils/NumberUtils'

export default class ChargeGroupCounter {
  constructor() {
  }

    // 应收
    static AR = 'ar';

    // 应付
    static AP = 'ap';

    // 应收应付
    static AR_AP = 'arAp';

    static OPERATOR_EQUAL = '=';
    static OPERATOR_NOT_EQUAL = '!=';
    static OPERATOR_GREAT_THEN = '>';
    static OPERATOR_LESS_THEN = '<';
    static OPERATOR_GREAT_EQUAL_THEN = '>=';
    static OPERATOR_LESS_EQUAL_THEN = '<=';

    static OPERATION_ADD = '+';
    static OPERATION_SUBTRACT = '-';
    static OPERATION_MULTIPLY = '*';
    static OPERATION_DIVIDE = '/';
    static OPERATION_IGNORE = '!';

    // 最左角显示的内容
    static HEADER = '币种';

    // 最左侧显示的内容的key值
    static HEADER_FIELD = 'dispName';

    // **** private ***
    // 默认汇率1
    static RATE_VALUE_DEFAULT = 1;

    // 默认统计字段名
    static COUNT_FIELD_DEFAULT = 'amount';

    // 默认汇率字段名
    static RATE_FIELD_DEFAULT = 'rate';

    // 默认币种字段
    static CURRENCY_VALUE_DEFAULT = 'RMB';

    // 默认币种字段名
    static CURRENCY_FIELD_DEFAULT = 'currency';

    /**
     * 检测是否符合条件
     * @param condition
     * @param row
     * @return
     */
    static checkCondition(dataAdapte, row) {
      let flag = true
      if (dataAdapte.field == null || !dataAdapte.field || !dataAdapte.operator || !dataAdapte.operator) { return flag }
      switch (dataAdapte.operator) {
        case ChargeGroupCounter.OPERATOR_EQUAL:
          if (!row.hasOwnProperty(dataAdapte.field) || row[dataAdapte.field] !== dataAdapte.value) { flag = false }
          break
        case ChargeGroupCounter.OPERATOR_NOT_EQUAL:
          if (row.hasOwnProperty(dataAdapte.field) && row[dataAdapte.field] === dataAdapte.value) { flag = false }
          break
        case ChargeGroupCounter.OPERATOR_GREAT_THEN:
          if (!row.hasOwnProperty(dataAdapte.field) || row[dataAdapte.field] < dataAdapte.value) { flag = false }
          break
        case ChargeGroupCounter.OPERATOR_LESS_THEN:
          if (!row.hasOwnProperty(dataAdapte.field) || row[dataAdapte.field] > dataAdapte.value) { flag = false }
          break
        case ChargeGroupCounter.OPERATOR_GREAT_EQUAL_THEN:
          if (!row.hasOwnProperty(dataAdapte.field) || row[dataAdapte.field] <= dataAdapte.value) { flag = false }
          break
        case ChargeGroupCounter.OPERATOR_LESS_EQUAL_THEN:
          if (!row.hasOwnProperty(dataAdapte.field) || row[dataAdapte.field] >= dataAdapte.value) { flag = false }
          break

        default:
          flag = false
      }
      return flag
    }

    /**
     * 数据是否具有符合条件的忽略器
     * @param dataAdaptes
     * @param row
     * @return
     */
    static getIgnoreDataAdapter(dataAdaptes, row) {
      let resultDataAdapte = null
      for (const dataAdapte of dataAdaptes) {
        if (ChargeGroupCounter.OPERATION_IGNORE === dataAdapte.operation) {
          resultDataAdapte = dataAdapte
          break
        }
      }
      return resultDataAdapte
    }

    /**
     * 数据处理器过滤器
     * @param dataAdapters
     * @param row
     * @return
     */
    static dataAdaptersFilter(dataAdaptes, row) {
      const adapters = []
      for (const dataAdapte of dataAdaptes) {
        if (this.checkCondition(dataAdapte, row)) {
          adapters.push(dataAdapte)
        }
      }
      return adapters
    }

    /**
     * 数据处理器
     * 1. 无任何数据处理器则返回NaN
     * 2. 获取到数据处理器则按照操作符操作
     * 3. dataAdapters,row,baseValue为空则返回NaN
     * 4. handlerValue 为空则返回baseValue
     * @param baseValue
     * @param handlerValue
     * @param dataAdapters
     * @param row 待处理行
     * @return
     */
    static dataAdaptersHandler(baseValue, handlerValue, dataAdaptes, row) {
      let result = new BigNumber(NaN)
      if (!dataAdaptes || !row || dataAdaptes.length < 1 || baseValue.isNaN() || new BigNumber(handlerValue).isNaN()) { result = new BigNumber(NaN) }
      const dataAdapte = this.getValidatedDataHandler(dataAdaptes, row)
      if (dataAdapte) { result = this.operationHandler(baseValue, handlerValue, dataAdapte) }
      return result
    }

    /**
     * 处理器操作符操作
     * @param baseValue
     * @param handlerValue
     * @param dataAdapter
     * @return
     */
    static operationHandler(baseValue, handlerValue, dataAdapter) {
      let result = baseValue
      switch (dataAdapter.operation) {
        case this.OPERATION_ADD :
          result = result.plus(handlerValue)
          break
        case this.OPERATION_SUBTRACT:
          result = result.minus(handlerValue)
          break
        case this.OPERATION_MULTIPLY:
          result = result.multipliedBy(handlerValue)
          break
        case this.OPERATION_DIVIDE:
          if (handlerValue === 0) { break }
          result = result.dividedBy(handlerValue)
          break
        case this.OPERATION_IGNORE:
          result = new BigNumber(NaN)
          break
        default:
      }
      return result
    }

    /**
     * 获取有效的处理器
     * 若数据不符合任何条件的则返回空null
     * 若具有忽略器,则优先返回忽略器
     * @param dataAdapters
     * @param row
     * @return
     */
    static getValidatedDataHandler(dataAdaptes, row) {
      const validatedAdaptes = this.dataAdaptersFilter(dataAdaptes, row)
      if (validatedAdaptes == null || validatedAdaptes.length <= 0) { return null }
      const ignoreDataAdapte = this.getIgnoreDataAdapter(validatedAdaptes, row)
      return ignoreDataAdapte == null ? validatedAdaptes[0] : ignoreDataAdapte
    }

    /**
     * 分组合计
     * 使用field.inGrid属性控制是否显示在详情窗口中
     * 若是显示在详情窗口中则分币中合计
     * 若是不显示在详情窗口中则折算合计
     */
    static groupingCalc(dataList, displayAndCountFieldList, basicCurrency, isCountDetail, source) {
      const result = {}
      const chargeCountWindowColumns = []
      const chargeCountWindowColumnsMap = {}
      const chargeCountGridResultList = []
      const chargeCountGroupResultList = []
      // console.log('groupingCalc=====displayAndCountFieldList=', displayAndCountFieldList)
      if (dataList && dataList.length !== 0 || displayAndCountFieldList && displayAndCountFieldList.length !== 0) {
        this.CURRENCY_VALUE_DEFAULT = RateUtil.localCurrencyByOffice()
        let scale = 2 // 小数位数
        let roundingMode = BigNumber.ROUND_HALF_UP
        const carryRule = RateUtil.useAmountCarryRule()
        for (const field of displayAndCountFieldList) {
          // 原始金额统计相关属性初始化
          const totalCurrencyMap = {}
          let countValue = new BigNumber(0)

          // 折合计算相关属性初始化
          let rateValue = this.RATE_VALUE_DEFAULT
          const countField = (field.countField == null || field.currencyField === '') ? this.COUNT_FIELD_DEFAULT : field.countField
          const currencyField = (field.currencyField == null || field.currencyField === '') ? this.CURRENCY_FIELD_DEFAULT : field.currencyField
          const rateField = (field.rateField == null || field.rateField === '') ? this.RATE_FIELD_DEFAULT : field.rateField
          let currencyValue = this.CURRENCY_VALUE_DEFAULT
          let totalTransformValue = new BigNumber(0)

          this.currencyMap = {}
          let itemAmount
          // let checkOriginal = false
          let itemCurrency = basicCurrency
          const currencyZeroAmountList = []
          const currencyRateMap = {}
          // 仅处理发票列表场景
          if (!field.inGrid && source === 'invoiceList') {
            // 判断是否单币种 且金额计算为0
            // 多币种暂无方案
            for (const row of dataList) {
              itemCurrency = row.hasOwnProperty(currencyField) ? row[currencyField] : this.CURRENCY_VALUE_DEFAULT
              if (!this.currencyMap.hasOwnProperty(itemCurrency)) {
                this.currencyMap[itemCurrency] = 0
              }
              if (!currencyRateMap.hasOwnProperty(itemCurrency)) {
                currencyRateMap[itemCurrency] = new Set()
              }
              // 汇率
              rateValue = row.hasOwnProperty(rateField)
                ? (isNaN(row[rateField]) ? this.RATE_VALUE_DEFAULT : row[rateField])
                : RateUtil.getForeignExchangeRateSafely(basicCurrency, currencyValue, new Date(), 0)
              rateValue = rateValue <= 0 ? RateUtil.getForeignExchangeRateSafely(basicCurrency, currencyValue, new Date(), 0) : rateValue
              currencyRateMap[itemCurrency].add(rateValue)
              const countField = (field.countField == null || field.currencyField === '') ? this.COUNT_FIELD_DEFAULT : field.countField
              itemAmount = row.hasOwnProperty(countField) ? (isNaN(row[countField]) ? 0 : row[countField]) : 0
              this.currencyMap[itemCurrency] = NumberUtils.ToFixed2(NumberUtils.ToFixed2(itemAmount, 2) + this.currencyMap[itemCurrency], 2)
            }
            Object.keys(this.currencyMap).forEach(key => {
              // 判断原币合计是否为0，保存该币种以便后续跳过折合计算
              if (this.currencyMap[key] === 0) {
                currencyZeroAmountList.push(key)
              }
            })
            // const currencyNum = Object.keys(this.currencyMap).length
            // // 币种数量为1 且金额为0
            // if (currencyNum === 1 && this.currencyMap[itemCurrency] === 0) {
            //   checkOriginal = true
            // }
          }
          for (const row of dataList) {
            // 原始币种
            currencyValue = row.hasOwnProperty(currencyField) ? row[currencyField] : this.CURRENCY_VALUE_DEFAULT

            // 汇率
            rateValue = row.hasOwnProperty(rateField)
              ? (isNaN(row[rateField]) ? this.RATE_VALUE_DEFAULT : row[rateField])
              : RateUtil.getForeignExchangeRateSafely(basicCurrency, currencyValue, new Date(), 0)
            rateValue = rateValue <= 0 ? RateUtil.getForeignExchangeRateSafely(basicCurrency, currencyValue, new Date(), 0) : rateValue

            // 金额
            if (row.hasOwnProperty(countField)) {
              countValue = new BigNumber(row[countField])
              countValue = countValue.isNaN() ? new BigNumber(0) : countValue
            } else { countValue = new BigNumber(0) }

            // CARGO-310，窗口折合RMB与折叠后的折合RMB金额不一致
            let amount2RMB = new BigNumber(0)
            // console.log('countValue=', countValue, 'field.countField=', field.countField, 'countField=', countField, 'row', row)
            if (countValue.toNumber() !== 0) {
              if (countField === 'amount') {
                if (row.hasOwnProperty('amount2RMB') && !new BigNumber(row['amount2RMB']).isNaN()) {
                  amount2RMB = new BigNumber(row['amount2RMB'])
                }
              } else if (countField === 'verifiedAmount') {
                if (row.hasOwnProperty('verifiedAmount2RMB') && !new BigNumber(row['verifiedAmount2RMB']).isNaN()) {
                  amount2RMB = new BigNumber(row['verifiedAmount2RMB'])
                }
              } else if (countField === 'unverifiedAmount') {
                if (row.hasOwnProperty('unverifiedAmount2RMB') && !new BigNumber(row['unverifiedAmount2RMB']).isNaN()) {
                  amount2RMB = new BigNumber(row['unverifiedAmount2RMB'])
                }
              }
            }

            let baseValue = new BigNumber(0)
            // 必须是统计显示表格的内容并且是在弹窗显示的状态下才会进行统计详情窗体的内容
            if (field.inGrid) {
              if (!isCountDetail) { continue }
              // 计算原始币种总金额
              if (totalCurrencyMap.hasOwnProperty(currencyValue)) {
                baseValue = ChargeGroupCounter.dataAdaptersHandler(new BigNumber(totalCurrencyMap[currencyValue]), countValue, field.dataAdapters, row)
              } else {
                baseValue = ChargeGroupCounter.dataAdaptersHandler(new BigNumber(0), countValue, field.dataAdapters, row)
                if (!chargeCountWindowColumnsMap.hasOwnProperty(currencyValue)) {
                  chargeCountWindowColumnsMap[currencyValue] = true
                  chargeCountWindowColumns.push(currencyValue)
                }
              }
              if (baseValue.isNaN()) {
                continue
              } else {
                totalCurrencyMap[currencyValue] = baseValue
              }
            } else {
              // 该币种原币金额合计为0且该币种不存在多个汇率，则不参与折合计算
              if (currencyZeroAmountList.includes(currencyValue) && currencyRateMap[itemCurrency].size <= 1) {
                continue
              }
              // 计算折合金额
              // console.log('totalTransformValue====', totalTransformValue,'amount2RMB=', amount2RMB,'field',field)
              //                        totalTransformValue = ChargeGroupCounter.dataAdaptersHandler(totalTransformValue, NumberUtils.roundHalfUp2(rateValue * countValue), field.dataAdapters, row);
              if (countField && ['totalInvoiceTaxExcludedRMB', 'amount2RMB'].includes(countField)) {
                const a = new BigNumber(row[countField])
                totalTransformValue = ChargeGroupCounter.dataAdaptersHandler(totalTransformValue, a, field.dataAdapters, row)
              } else {
                if (carryRule && currencyValue) {
                  const currencyData = RateUtil.getCurrency(currencyValue)
                  if (currencyData !== null) {
                    scale = currencyData.defaultFractionDigits
                    if (currencyData.carryRule === 1) { // 进位规则：0=四合五入、1=舍位
                      roundingMode = BigNumber.ROUND_DOWN
                    } else {
                      roundingMode = BigNumber.ROUND_HALF_UP
                    }
                  }
                }
                totalTransformValue = ChargeGroupCounter.dataAdaptersHandler(totalTransformValue, (amount2RMB.toNumber() === 0) ? countValue.multipliedBy(rateValue).toFixed(scale, roundingMode) : amount2RMB.toFixed(scale, roundingMode), field.dataAdapters, row)
              }
            }
          }
          if (field.inGrid) {
            totalCurrencyMap[ChargeGroupCounter.HEADER_FIELD] = field.fieldName
            chargeCountGridResultList.push(totalCurrencyMap)
          } else {
            // if (checkOriginal) {
            //   const item = this.chargeCountItemStyleHandler(field, new BigNumber(0), basicCurrency)
            //   chargeCountGroupResultList.push(item)
            // } else {
            //   const item = this.chargeCountItemStyleHandler(field, totalTransformValue, basicCurrency)
            //   chargeCountGroupResultList.push(item)
            // }
            const item = this.chargeCountItemStyleHandler(field, totalTransformValue, basicCurrency)
            chargeCountGroupResultList.push(item)
          }
        }
      }
      result['chargeCountGroupResultList'] = (chargeCountGroupResultList)
      result['chargeCountGridResultList'] = (chargeCountGridResultList)
      result['chargeCountWindowColumns'] = chargeCountWindowColumns
      return result
    }

    static groupingCalcNew(dataList, displayAndCountFieldList, isCountDetail) {
      const result = {}
      const chargeCountWindowColumns = []
      const chargeCountGridResultList = []
      const chargeCountGroupResultList = []
      if (dataList != null && dataList.length !== 0 || displayAndCountFieldList != null && displayAndCountFieldList.length !== 0) {
        const basicCurrency = RateUtil.localCurrencyByOffice()
        this.CURRENCY_VALUE_DEFAULT = basicCurrency
        let scale = 2 // 小数位数
        let roundingMode = BigNumber.ROUND_HALF_UP
        const carryRule = RateUtil.useAmountCarryRule()
        for (const field of displayAndCountFieldList) {
          // 原始金额统计相关属性初始化
          let totalCurrencyMap = {}
          let countValue = new BigNumber(0)

          // 折合计算相关属性初始化
          let rateValue = this.RATE_VALUE_DEFAULT
          const countField = (field.countField == null || field.currencyField === '') ? this.COUNT_FIELD_DEFAULT : field.countField
          const currencyField = (field.currencyField == null || field.currencyField === '') ? this.CURRENCY_FIELD_DEFAULT : field.currencyField
          const rateField = (field.rateField == null || field.rateField === '') ? this.RATE_FIELD_DEFAULT : field.rateField
          let currencyValue = this.CURRENCY_VALUE_DEFAULT
          let totalTransformValue = new BigNumber(0)
          // for(let row:Invoice in dataList) {
          for (const row of dataList) {
            // 原始币种
            currencyValue = row.hasOwnProperty(currencyField) ? row[currencyField] : this.CURRENCY_VALUE_DEFAULT

            // 汇率
            rateValue = row.hasOwnProperty(rateField)
              ? (isNaN(row[rateField]) ? this.RATE_VALUE_DEFAULT : row[rateField])
              : RateUtil.getForeignExchangeRateSafely(basicCurrency, currencyValue, new Date(), 0)
            rateValue = rateValue <= 0 ? RateUtil.getForeignExchangeRateSafely(basicCurrency, currencyValue, new Date(), 0) : rateValue

            // 金额
            if (row.hasOwnProperty(countField)) {
              countValue = new BigNumber(row[countField])
              countValue = countValue.isNaN() ? new BigNumber(0) : countValue
            } else { countValue = new BigNumber(0) }

            // CARGO-310，窗口折合RMB与折叠后的折合RMB金额不一致
            let amount2RMB = new BigNumber(0)
            if (countValue.toNumber() !== 0) {
              if (countField === 'amount') {
                if (row.hasOwnProperty('amount2RMB') && !new BigNumber(row['amount2RMB']).isNaN()) {
                  amount2RMB = new BigNumber(row['amount2RMB'])
                }
              } else if (countField === 'verifiedAmount') {
                if (row.hasOwnProperty('verifiedAmount2RMB') && !new BigNumber(row['verifiedAmount2RMB']).isNaN()) {
                  amount2RMB = new BigNumber(row['verifiedAmount2RMB'])
                }
              } else if (countField === 'unverifiedAmount') {
                if (row.hasOwnProperty('unverifiedAmount2RMB') && !new BigNumber(row['unverifiedAmount2RMB']).isNaN()) {
                  amount2RMB = new BigNumber(row['unverifiedAmount2RMB'])
                }
              }
            }

            // 必须是统计显示表格的内容并且是在弹窗显示的状态下才会进行统计详情窗体的内容
            if (field.inGrid) {
              if (!isCountDetail) { continue }

              const dataAdapte = this.getValidatedDataHandler(field.dataAdapters, row)
              if (dataAdapte == null) {
                continue
              }
              if (row.hasOwnProperty('currencyObject')) {
                for (const c in row.currencyObject) {
                  if (chargeCountWindowColumns.indexOf(c) < 0) {
                    chargeCountWindowColumns.push(c)
                  }
                  // 合计 或者 应收 或者 应付
                  if ((field.dataAdapters.length === 2) || (row.isAr && dataAdapte.value) ||
                      (!row.isAr && !dataAdapte.value)) {
                    totalCurrencyMap = this.calculationAmount(totalCurrencyMap, c, row, dataAdapte)
                  }
                }
              } else {
                if (chargeCountWindowColumns.indexOf(currencyValue) < 0) {
                  chargeCountWindowColumns.push(currencyValue)
                }
                if ((field.dataAdapters.length === 2) || (row.isAr && dataAdapte.value) ||
                    (!row.isAr && !dataAdapte.value)) {
                  totalCurrencyMap = this.calculationAmount2(totalCurrencyMap, currencyValue, countValue, dataAdapte)
                }
              }
            } else {
              if (carryRule && currencyValue) {
                const currencyData = RateUtil.getCurrency(currencyValue)
                if (currencyData !== null) {
                  scale = currencyData.defaultFractionDigits
                  if (currencyData.carryRule === 1) { // 进位规则：0=四合五入、1=舍位
                    roundingMode = BigNumber.ROUND_DOWN
                  } else {
                    roundingMode = BigNumber.ROUND_HALF_UP
                  }
                }
              }
              // 计算折合金额
              totalTransformValue = ChargeGroupCounter.dataAdaptersHandler(totalTransformValue, (amount2RMB.toNumber() === 0) ? countValue.multipliedBy(rateValue).toFixed(scale, roundingMode) : amount2RMB.toFixed(scale, roundingMode), field.dataAdapters, row)
            }
          }
          if (field.inGrid) {
            totalCurrencyMap[ChargeGroupCounter.HEADER_FIELD] = field.fieldName
            chargeCountGridResultList.push(totalCurrencyMap)
          } else {
            const item = this.chargeCountItemStyleHandler(field, totalTransformValue, basicCurrency)
            chargeCountGroupResultList.push(item)
          }
        }
      }
      result['chargeCountGroupResultList'] = (chargeCountGroupResultList)
      result['chargeCountGridResultList'] = (chargeCountGridResultList)
      result['chargeCountWindowColumns'] = chargeCountWindowColumns
      return result
    }

    static groupingCalcByJob(dataList, displayAndCountFieldList, isCountDetail, dataField) {
      const result = {}
      const chargeCountWindowColumns = []
      const chargeCountGridResultList = []
      const chargeCountGroupResultList = []
      if (dataList != null && dataList.length !== 0 || displayAndCountFieldList != null && displayAndCountFieldList.length !== 0) {
        const basicCurrency = RateUtil.localCurrencyByOffice()
        this.CURRENCY_VALUE_DEFAULT = basicCurrency
        let scale = 2 // 小数位数
        let roundingMode = BigNumber.ROUND_HALF_UP
        const carryRule = RateUtil.useAmountCarryRule()
        for (const field of displayAndCountFieldList) {
          // 原始金额统计相关属性初始化
          let totalCurrencyMap = {}
          let countValue = new BigNumber(0)

          // 折合计算相关属性初始化
          let rateValue = this.RATE_VALUE_DEFAULT
          const countField = (field.countField == null || field.currencyField === '') ? this.COUNT_FIELD_DEFAULT : field.countField
          const currencyField = (field.currencyField == null || field.currencyField === '') ? this.CURRENCY_FIELD_DEFAULT : field.currencyField
          let currencyValue = this.CURRENCY_VALUE_DEFAULT
          let totalTransformValue = new BigNumber(0)

          for (const row of dataList) {
            // 原始币种
            currencyValue = row.hasOwnProperty(currencyField) ? row[currencyField] : this.CURRENCY_VALUE_DEFAULT

            // 汇率
            rateValue = row.charge_exchangeRate

            // 金额
            if (row.hasOwnProperty(countField)) {
              countValue = new BigNumber(row[countField])
              countValue = countValue.isNaN() ? new BigNumber(0) : countValue
            } else { countValue = new BigNumber(0) }

            // CARGO-310，窗口折合RMB与折叠后的折合RMB金额不一致
            let amount2RMB = new BigNumber(0)
            if (row[dataField] != null && row.charge_exchangeRate != null) {
              amount2RMB = new BigNumber(row[dataField]).multipliedBy(row.charge_exchangeRate)
            }

            // 必须是统计显示表格的内容并且是在弹窗显示的状态下才会进行统计详情窗体的内容
            if (field.inGrid) {
              if (!isCountDetail) { continue }

              const dataAdapte = this.getValidatedDataHandler(field.dataAdapters, row)
              if (dataAdapte == null) {
                continue
              }
              if (chargeCountWindowColumns.indexOf(currencyValue) < 0) {
                chargeCountWindowColumns.push(currencyValue)
              }
              // 合计 或者 应收 或者 应付
              if ((field.dataAdapters.length === 2) || (row.charge_receivable && dataAdapte.value) ||
                (!row.charge_receivable && !dataAdapte.value)) {
                totalCurrencyMap = this.calculationAmount2(totalCurrencyMap, currencyValue, new BigNumber(row[dataField]), dataAdapte)
              }
            } else {
              if (carryRule && currencyValue) {
                const currencyData = RateUtil.getCurrency(currencyValue)
                if (currencyData !== null) {
                  scale = currencyData.defaultFractionDigits
                  if (currencyData.carryRule === 1) { // 进位规则：0=四合五入、1=舍位
                    roundingMode = BigNumber.ROUND_DOWN
                  } else {
                    roundingMode = BigNumber.ROUND_HALF_UP
                  }
                }
              }
              // 计算折合金额
              totalTransformValue = ChargeGroupCounter.dataAdaptersHandler(totalTransformValue, (amount2RMB.toNumber() === 0) ? countValue.multipliedBy(rateValue).toFixed(scale, roundingMode) : amount2RMB.toFixed(scale, roundingMode), field.dataAdapters, row)
            }
          }
          if (field.inGrid) {
            totalCurrencyMap[ChargeGroupCounter.HEADER_FIELD] = field.fieldName
            chargeCountGridResultList.push(totalCurrencyMap)
          } else {
            const item = this.chargeCountItemStyleHandler(field, totalTransformValue, basicCurrency)
            chargeCountGroupResultList.push(item)
          }
        }
      }
      result['chargeCountGroupResultList'] = (chargeCountGroupResultList)
      result['chargeCountGridResultList'] = (chargeCountGridResultList)
      result['chargeCountWindowColumns'] = chargeCountWindowColumns
      return result
    }

    static calculationAmount(totalCurrencyMap, c, row, dataAdapte) { // row:Invoice
      switch (dataAdapte.operation) {
        case this.OPERATION_ADD :
          if (totalCurrencyMap[c] == null) {
            totalCurrencyMap[c] = new BigNumber(row.currencyObject[c])
          } else {
            totalCurrencyMap[c] = totalCurrencyMap[c].plus(row.currencyObject[c])
          }
          break
        case this.OPERATION_SUBTRACT:
          if (totalCurrencyMap[c] == null) {
            totalCurrencyMap[c] = new BigNumber(row.currencyObject[c]).multipliedBy(-1)
          } else {
            totalCurrencyMap[c] = totalCurrencyMap[c].minus(row.currencyObject[c])
          }
          break
      }
      return totalCurrencyMap
    }

    static calculationAmount2(totalCurrencyMap, c, amount, dataAdapte) {
      switch (dataAdapte.operation) {
        case this.OPERATION_ADD :
          if (totalCurrencyMap[c] == null) {
            totalCurrencyMap[c] = amount
          } else {
            totalCurrencyMap[c] = totalCurrencyMap[c].plus(amount)
          }
          break
        case this.OPERATION_SUBTRACT:
          if (totalCurrencyMap[c] == null) {
            totalCurrencyMap[c] = amount.multipliedBy(-1)
          } else {
            totalCurrencyMap[c] = totalCurrencyMap[c].minus(amount)
          }
          break
      }
      return totalCurrencyMap
    }

    /**
     * 特别值的样式
     * @param field
     * @param amount
     * @param basicCurrency
     * @return
     */
    static chargeCountItemStyleHandler(field, amount, basicCurrency) {
      const styleMap = {}
      styleMap['text-decoration'] = 'underline'
      // TODO 判断是否收益
      if (amount.isLessThan(0)) {
        styleMap['color'] = 0xff0000
      }
      const item = new ChargeCountItem(field.fieldName, basicCurrency, amount, styleMap)
      return item
    }
}
